const details = {
    name: "درنیکا پک",
    enName: "shop",
    description: "درنیکا پک",
    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت طراحی سایت باران",
        link: "https://barantm.com/online-shops"
    }
}

export default details;
